import { useCompanyUserStatisticQuery } from "@generated/graphql";
import { ApartmentOutlined, GroupsOutlined } from "@mui/icons-material";
import { Box, Stack, Typography } from "@mui/material";
import TabLayout from "layout/TabLayout";
import { Tab } from "layout/TabLayout/types";
import { palette } from "theme";
import Header from "./components/Header";
import InfoTab from "./components/InfoTab";
import TeamTab from "./components/TeamTab";

const CompanyPage = () => {
  const { data: statisticData, loading: isStatisticLoading } = useCompanyUserStatisticQuery();
  const teamMembersCount = isStatisticLoading ? "-" : (statisticData?.companyUserStatistic.totalCount ?? 0);

  const tabs: Tab[] = [
    {
      title: "Данные компании",
      startIcon: <ApartmentOutlined />,
      id: "info",
      component: <InfoTab />,
    },
    {
      title: (
        <Stack
          spacing={1}
          direction='row'
          useFlexGap>
          Команда
          <Typography
            sx={{
              color: "unset",
              fontWeight: "unset",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              backgroundColor: palette.base[70],
              px: 1,
              borderRadius: 999,
            }}>
            {teamMembersCount}
          </Typography>
        </Stack>
      ),
      startIcon: <GroupsOutlined />,
      id: "team",
      component: (
        <TeamTab
          statistic={statisticData?.companyUserStatistic}
          isStatisticLoading={isStatisticLoading}
        />
      ),
    },
  ];

  return (
    <Box>
      <Stack spacing={3}>
        <Header />
        <TabLayout
          tabs={tabs}
          defaultTab='info'
          variant='redesign'
          withSearchParams
          tabListProps={{
            sx: {
              mb: 2,
            },
          }}
        />
      </Stack>
    </Box>
  );
};

export default CompanyPage;
